import { isBrowser } from '@/utils/env';
import { nextTask } from '@/utils/promiseUtils';

// Returns a promise which resolves when the load event fires, or immediately if already fired
export function loadEventFired(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'object') {
      return reject(new Error('load event cannot fire outside the browser'));
    }
    if (window.document.readyState === 'complete') {
      return resolve();
    }
    window.addEventListener('load', () => resolve());
  });
}

export async function performanceTimingReady(): Promise<boolean> {
  if (!isBrowser()) {
    throw new Error('performance.timing is not available on the server');
  }

  // Perf metrics aren't ready until the first task after the load event fires
  await loadEventFired();
  await nextTask();

  return !!(window?.performance?.timing?.loadEventEnd ?? false);
}
